import { render } from "./AuAIChat.vue?vue&type=template&id=faf40be8&scoped=true"
import script from "./AuAIChat.vue?vue&type=script&lang=js"
export * from "./AuAIChat.vue?vue&type=script&lang=js"

import "./AuAIChat.vue?vue&type=style&index=0&id=faf40be8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf40be8"]])

export default __exports__